<template>
  <div class="client-center">
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button
          @click="$router.push({ name: 'add-customer' })"
          type="primary"
          icon="plus"
        >
          新增企业
        </a-button>
      </div>
      <TableView
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :loading="loading"
        :scroll="scroll"
        @handlePagination="handlePagination"
      >
        <template v-slot:custom=""><span>xxx</span></template>
        <!--所属角色 slot-->
        <template v-slot:roleNames="{ tableRow }">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ tableRow.roleNames.join(',') }}</span>
            </template>
            <span>{{ tableRow.roleNames.join(',') }}</span>
          </a-tooltip>
        </template>
        <!--所属部门 slot-->
        <template v-slot:department="{ tableRow }">
          <span>{{ tableRow.department | department }}</span>
        </template>
        <!--状态 slot-->
        <template v-slot:status="{ tableRow }">
          <span>
            <a-tag :color="tableRow.status === 1 ? 'green' : 'volcano'">
              {{ tableRow.status === 1 ? '激活' : '冻结' }}
            </a-tag>
          </span>
        </template>
        <!--操作 slot-->
        <template v-slot:action="{ tableRow }">
          <a href="javascript:void(0)" @click="handelView(tableRow)" v-if="tableRow.status == 1">
            查看详情
          </a>
          <a-button type="link" size="small" v-if="tableRow.status == 2" @click="handleBlackView(tableRow)">
            查看详情
          </a-button>
          <a-divider type="vertical" />
          <a-popconfirm
            v-if="tableRow.status == 1"
            title="是否加入黑名单?"
            @confirm="() => submitAddBlacklist(tableRow)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a href="javascript:void(0)" @click="handleBlacklist(tableRow)">
              加入黑名单
            </a>
          </a-popconfirm>
          <a @click="handleClick(tableRow)" v-if="tableRow.status == 2 && isAdmin">移出黑名单</a >
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import {
  getListCManager,
  getPage,
  addBlackList,
  getCustomerOverview,
  getBusinessList,
  getRegionList,
  removedBlacklist,
  checkIsAdmin,
} from './api'
import { SET_COMPANY, SET_PERMISSIONS } from 'config/mutation-types/app'
import { mapMutations } from 'vuex'
import { arrayToObject } from 'utils/util'
import { ERR_OK } from '@/config'
const CREDIT_MODEL_TYPE = 3
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  computed: {
    //搜索-信用主管
    getAllListCManager() {
      return [{ label: '全部', value: '' }].concat(
        this.sourceDataBasic.creditManager,
      )
    },
  },
  data() {
    return {
      loading: false,
      scroll: { x: 1600 }, //滚动设置
      formLayout: 'inline',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`,
      },
      oId: '', //row id
      cManagerList: [],
      modelList: [],
      visibleAdd: false,
      permissions: [],
      busiList: [],
      isAdmin: false,  //判断是否管理员角色
    }
  },
  updated() {
    this.searchSchema[2].selectList = [{ text: '全部', value: '' }].concat(
      this.cManagerList,
    )
    this.searchSchema[3].selectList = [{ text: '全部', value: '' }].concat(
      this.busiList,
    )
  },
  mounted() {
    this._checkIsAdmin()
    this._getTableData()
    this._getListCManager()
    this._getBusinessList()
  },

  methods: {
    // 检查是否为系统管理员角色
    async _checkIsAdmin() {
      const { code, data } = await checkIsAdmin()
      if (code === ERR_OK) {
        this.isAdmin = data.roleAdmin
      }
    },
    // 获取业务模式列表
    async _getRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.modelList = data.map(item => ({
          text: item.name,
          value: item.id,
        }))
        this.modelList.unshift({ text: '全部', value: '' })
        this.searchSchema[4]['selectList'] = this.modelList
      } catch (error) {
        console.log(error)
      }
    },

    handleModelChange(option) {
      if (option === undefined) {
        this.searchSchema[4]['selectList'] = []
        return
      }
      this._getRegionList(option, CREDIT_MODEL_TYPE)
    },

    ...mapMutations('app', [SET_COMPANY, SET_PERMISSIONS]),
    //获取table数据
    async _getTableData() {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        delete query.pageSize
        const {
          data: { total, records },
        } = await getPage(query)
        this.tableData = records
        this.pageData.total = total
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    async _getBusinessList() {
      try {
        const { data } = await getBusinessList()
        this.busiList = data.map(item => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      this.pageData.current = 1
      for (let key in query) {
        this.searchData[key] = query[key]
      }
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    // 加入黑名单
    handleBlacklist(row) {
      this.oId = row.id
    },
    // 提交黑名单
    async submitAddBlacklist() {
      try {
        await addBlackList(this.oId)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
    //移出黑名单
    handleClick(row) {
      this.$confirm({
        title: '提示',
        content: '是否移出黑名单?',
        okButtonProps: {
          loading: this.loading,
        },
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
          this.loading = true
          return this._removedBlacklist(row.id)
        },
      })
    },
    _removedBlacklist(id) {
      // const { id } = this.$route.params
      return removedBlacklist(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        // this.$router.push({ name: 'client-center' })
        this._getTableData()
      })
    },
    //信用主管
    async _getListCManager() {
      try {
        const { data } = await getListCManager()
        this.cManagerList = data.map(item => {
          return {
            text: item.name + '-' + item.username,
            value: item.username,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    // tab项中对应的权限
    permissionsObj() {
      if (this.permissions) {
        return arrayToObject(this.permissions, 'tab', 'buttons')
      }
      return {}
    },
    async handelView(row) {
      const { name, code, id } = row
      this.SET_COMPANY({ name, code })
      this.$router.push({ name: 'trend', params: { id, code } })
      const {
        data: { permissions },
      } = await getCustomerOverview(id)
      this.permissions = permissions
      this.SET_PERMISSIONS(this.permissionsObj())
    },
    //查看黑名单详情
    handleBlackView({ id }) {
      this.$router.push({ name: 'blacklist-details', params: { id,backType:1 } })
    },
    showDrawer() {
      this.visibleAdd = true
    },
    onClose() {
      this.visibleAdd = false
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
